module.exports = __webpack_public_path__ + "img/other_1plus3.49a9dd41.jpg";